import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'location-access-error-dialog',
  templateUrl: './location-access-error-dialog.component.html',
  styleUrls: ['./location-access-error-dialog.component.scss']
})
export class LocationAccessErrorDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
